
    import "/home/git/waysglob/website/src/components/how-we-help-items-group/index.module.scss.FARM_CSS_MODULES?7bc9bc4c";
    
    export default {"wrapper": `wrapper-3863fb54`,"title-wrapper": `title-wrapper-3863fb54`,"items-wrapper": `items-wrapper-3863fb54`}
    